import { defineTokens } from '@chakra-ui/react';

import { aiGradient, partialPrimaryGradient, pricingHighlight, softOrangeFade } from '../primitives/colors';

export const GRADIENTS = defineTokens({
  gradients: {
    primary: { value: partialPrimaryGradient },
    ai: { value: aiGradient },
    pricingHighlight: { value: pricingHighlight },
    softOrangeFade: { value: softOrangeFade },
  },
});
